import { getDocumentFilesTypes } from './get-document-file-types';
import { getImageFileTypes } from './get-image-file-types';

export function getAllFileTypes(): string[] {
    return [...getDocumentFilesTypes(), ...getImageFileTypes()];
}
